var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import { Query } from '@syncfusion/ej2-data';
/** Error codes for formula evaluation */
export var FormulaErrorCode;
(function (FormulaErrorCode) {
    FormulaErrorCode["PARSE"] = "#PARSE!";
    FormulaErrorCode["REF"] = "#REF!";
    FormulaErrorCode["NAME"] = "#NAME?";
    FormulaErrorCode["CIRCREF"] = "#CIRCREF!";
    FormulaErrorCode["VALUE"] = "#VALUE!";
    FormulaErrorCode["DIVZERO"] = "#DIV/0!";
    FormulaErrorCode["ERROR"] = "#ERROR!";
})(FormulaErrorCode || (FormulaErrorCode = {}));
/** Base error class for all formula-related errors */
var FormulaError = /** @class */ (function (_super) {
    __extends(FormulaError, _super);
    function FormulaError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = 'FormulaError';
        Object.setPrototypeOf(_this, FormulaError.prototype);
        return _this;
    }
    FormulaError.prototype.toString = function () {
        return this.code;
    };
    return FormulaError;
}(Error));
export { FormulaError };
// Specialized error classes
var ParseError = /** @class */ (function (_super) {
    __extends(ParseError, _super);
    function ParseError(message, position) {
        var _this = _super.call(this, FormulaErrorCode.PARSE, "Parse error: " + message) || this;
        _this.position = position;
        _this.name = 'ParseError';
        return _this;
    }
    return ParseError;
}(FormulaError));
export { ParseError };
var ReferenceError = /** @class */ (function (_super) {
    __extends(ReferenceError, _super);
    function ReferenceError(message) {
        var _this = _super.call(this, FormulaErrorCode.REF, "Reference error: " + message) || this;
        _this.name = 'ReferenceError';
        return _this;
    }
    return ReferenceError;
}(FormulaError));
export { ReferenceError };
var CycleError = /** @class */ (function (_super) {
    __extends(CycleError, _super);
    function CycleError(message) {
        var _this = _super.call(this, FormulaErrorCode.CIRCREF, "Circular reference: " + message) || this;
        _this.name = 'CycleError';
        return _this;
    }
    return CycleError;
}(FormulaError));
export { CycleError };
var DivideByZeroError = /** @class */ (function (_super) {
    __extends(DivideByZeroError, _super);
    function DivideByZeroError(message) {
        if (message === void 0) { message = 'Division by zero'; }
        var _this = _super.call(this, FormulaErrorCode.DIVZERO, message) || this;
        _this.name = 'DivideByZeroError';
        return _this;
    }
    return DivideByZeroError;
}(FormulaError));
export { DivideByZeroError };
var TypeMismatchError = /** @class */ (function (_super) {
    __extends(TypeMismatchError, _super);
    function TypeMismatchError(message) {
        var _this = _super.call(this, FormulaErrorCode.VALUE, "Type error: " + message) || this;
        _this.name = 'TypeMismatchError';
        return _this;
    }
    return TypeMismatchError;
}(FormulaError));
export { TypeMismatchError };
var UnknownFunctionError = /** @class */ (function (_super) {
    __extends(UnknownFunctionError, _super);
    function UnknownFunctionError(message) {
        var _this = _super.call(this, FormulaErrorCode.NAME, "Unknown function: " + message) || this;
        _this.name = 'UnknownFunctionError';
        return _this;
    }
    return UnknownFunctionError;
}(FormulaError));
export { UnknownFunctionError };
/** Base abstract class for all AST nodes */
var ASTNode = /** @class */ (function () {
    function ASTNode() {
    }
    return ASTNode;
}());
export { ASTNode };
/** Literal value node (number, string, boolean) */
var LiteralNode = /** @class */ (function (_super) {
    __extends(LiteralNode, _super);
    function LiteralNode(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    LiteralNode.prototype.accept = function (visitor) {
        return visitor.visitLiteral(this);
    };
    return LiteralNode;
}(ASTNode));
export { LiteralNode };
/** Cell reference node (e.g., A1, $B$2) */
var CellRefNode = /** @class */ (function (_super) {
    __extends(CellRefNode, _super);
    function CellRefNode(ref, isAbsolute) {
        if (isAbsolute === void 0) { isAbsolute = { col: false, row: false }; }
        var _this = _super.call(this) || this;
        _this.ref = ref;
        _this.isAbsolute = isAbsolute;
        return _this;
    }
    CellRefNode.prototype.accept = function (visitor) {
        return visitor.visitCellRef(this);
    };
    return CellRefNode;
}(ASTNode));
export { CellRefNode };
/** Range reference node (e.g., A1:B5) */
var RangeRefNode = /** @class */ (function (_super) {
    __extends(RangeRefNode, _super);
    function RangeRefNode(start, end) {
        var _this = _super.call(this) || this;
        _this.start = start;
        _this.end = end;
        return _this;
    }
    RangeRefNode.prototype.accept = function (visitor) {
        return visitor.visitRangeRef(this);
    };
    return RangeRefNode;
}(ASTNode));
export { RangeRefNode };
/** Binary operation node (e.g., A + B) */
var BinaryOpNode = /** @class */ (function (_super) {
    __extends(BinaryOpNode, _super);
    function BinaryOpNode(operator, left, right) {
        var _this = _super.call(this) || this;
        _this.operator = operator;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    BinaryOpNode.prototype.accept = function (visitor) {
        return visitor.visitBinaryOp(this);
    };
    return BinaryOpNode;
}(ASTNode));
export { BinaryOpNode };
/** Unary operation node (e.g., -A, +A) */
var UnaryOpNode = /** @class */ (function (_super) {
    __extends(UnaryOpNode, _super);
    function UnaryOpNode(operator, operand) {
        var _this = _super.call(this) || this;
        _this.operator = operator;
        _this.operand = operand;
        return _this;
    }
    UnaryOpNode.prototype.accept = function (visitor) {
        return visitor.visitUnaryOperator(this);
    };
    return UnaryOpNode;
}(ASTNode));
export { UnaryOpNode };
/** Function call node (e.g., SUM(A1:A5)) */
var FunctionCallNode = /** @class */ (function (_super) {
    __extends(FunctionCallNode, _super);
    function FunctionCallNode(name, args) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.args = args;
        return _this;
    }
    FunctionCallNode.prototype.accept = function (visitor) {
        return visitor.visitFunctionCall(this);
    };
    return FunctionCallNode;
}(ASTNode));
export { FunctionCallNode };
/** Lexer: Tokenizes formula strings into tokens */
var Lexer = /** @class */ (function () {
    function Lexer() {
        this.formula = '';
        this.position = 0;
        this.tokens = [];
    }
    /**
     * Tokenizes a formula string into a collection of tokens.
     *
     * @param {string} formula - The formula string to tokenize.
     * @returns {Token[]} The tokens extracted from the formula string.
     */
    Lexer.prototype.tokenize = function (formula) {
        this.formula = formula;
        this.position = 0;
        this.tokens = [];
        if (this.peek() === '=') {
            this.tokens.push({ type: 'equals', value: '=', position: 0 });
            this.advance();
        }
        while (this.position < this.formula.length) {
            var currentChar = this.peek();
            if (this.isWhitespace(currentChar)) {
                this.advance();
            }
            else if (this.isOperator(currentChar) || this.isComparisonOperator(currentChar)) {
                this.parseOperator();
            }
            else if (this.isDelimiter(currentChar)) {
                this.parseDelimiter();
            }
            else if (this.isDigit(currentChar)) {
                this.parseNumber();
            }
            else if (currentChar === '"') {
                this.parseStringLiteral();
            }
            else if (this.isReferenceStart(currentChar)) {
                this.parseReferenceOrFunction();
            }
            else {
                throw new ParseError("Unexpected character: '" + currentChar + "'", this.position);
            }
        }
        return this.tokens;
    };
    Lexer.prototype.parseOperator = function () {
        var startPosition = this.position;
        var currentChar = this.peek();
        var nextChar = this.peekNext();
        if (nextChar === '=') {
            this.advance();
            this.advance();
            this.tokens.push({ type: 'comparison', value: currentChar + nextChar, position: startPosition });
        }
        else if (currentChar === '<' && nextChar === '>') {
            this.advance();
            this.advance();
            this.tokens.push({ type: 'comparison', value: '<>', position: startPosition });
        }
        else {
            this.advance();
            var type = this.isComparisonOperator(currentChar) ? 'comparison' : 'operator';
            this.tokens.push({ type: type, value: currentChar, position: startPosition });
        }
    };
    Lexer.prototype.parseDelimiter = function () {
        var startPosition = this.position;
        this.tokens.push({ type: 'delimiter', value: this.peek(), position: startPosition });
        this.advance();
    };
    Lexer.prototype.parseNumber = function () {
        var tokenStartPosition = this.position;
        var numberLiteral = '';
        while (this.position < this.formula.length) {
            var currentChar = this.peek();
            if (!this.isDigit(currentChar) && currentChar !== '.') {
                break;
            }
            numberLiteral += currentChar;
            this.advance();
        }
        if (this.position < this.formula.length) {
            var currentChar = this.peek();
            if (currentChar === 'e' || currentChar === 'E') {
                numberLiteral += currentChar;
                this.advance();
                if (this.position < this.formula.length) {
                    currentChar = this.peek();
                    if (currentChar === '+' || currentChar === '-') {
                        numberLiteral += currentChar;
                        this.advance();
                    }
                }
                while (this.position < this.formula.length) {
                    currentChar = this.peek();
                    if (!this.isDigit(currentChar)) {
                        break;
                    }
                    numberLiteral += currentChar;
                    this.advance();
                }
            }
        }
        var numericValue = parseFloat(numberLiteral);
        if (isNaN(numericValue)) {
            throw new ParseError("Invalid number: " + numberLiteral, tokenStartPosition);
        }
        this.tokens.push({ type: 'number', value: numericValue, position: tokenStartPosition });
    };
    Lexer.prototype.parseStringLiteral = function () {
        var startPosition = this.position;
        var stringValue = '';
        this.advance();
        while (this.position < this.formula.length) {
            var currentChar = this.peek();
            if (currentChar === '"') {
                break;
            }
            if (currentChar === '\\' && this.peekNext() === '"') {
                stringValue += '"';
                this.advance();
                this.advance();
                continue;
            }
            stringValue += currentChar;
            this.advance();
        }
        if (this.position >= this.formula.length) {
            throw new ParseError('Unterminated string literal', startPosition);
        }
        this.advance();
        this.tokens.push({ type: 'string', value: stringValue, position: startPosition });
    };
    Lexer.prototype.parseReferenceOrFunction = function () {
        var startPosition = this.position;
        var identifier = '';
        if (this.peek() === '$') {
            identifier += '$';
            this.advance();
        }
        while (this.position < this.formula.length && this.isLetter(this.peek())) {
            identifier += this.peek();
            this.advance();
        }
        if (this.peek() === '$') {
            identifier += '$';
            this.advance();
        }
        while (this.position < this.formula.length && this.isDigit(this.peek())) {
            identifier += this.peek();
            this.advance();
        }
        var normalizedIdentifier = identifier.toUpperCase();
        if (this.peek() === '(' || /^[A-Za-z]+$/.test(identifier)) {
            this.tokens.push({ type: 'function', value: normalizedIdentifier, position: startPosition });
            return;
        }
        if (/^\$?[A-Za-z]+\$?[0-9]+$/.test(identifier)) {
            this.tokens.push({ type: 'reference', value: normalizedIdentifier, position: startPosition });
            return;
        }
        throw new ParseError("Invalid reference: " + identifier, startPosition);
    };
    Lexer.prototype.isOperator = function (char) { return /[+\-*/%^×÷]/.test(char); };
    Lexer.prototype.isComparisonOperator = function (char) { return /[<>=]/.test(char); };
    Lexer.prototype.isDelimiter = function (char) { return /[(),:]/.test(char); };
    Lexer.prototype.isDigit = function (char) { return /[0-9]/.test(char); };
    Lexer.prototype.isLetter = function (char) { return /[a-zA-Z]/.test(char); };
    Lexer.prototype.isWhitespace = function (char) { return /\s/.test(char); };
    Lexer.prototype.isReferenceStart = function (char) { return this.isLetter(char) || char === '$'; };
    Lexer.prototype.peek = function () { return this.position < this.formula.length ? this.formula[this.position] : '\0'; };
    Lexer.prototype.peekNext = function () { return this.position + 1 < this.formula.length ? this.formula[this.position + 1] : '\0'; };
    Lexer.prototype.advance = function () { this.position++; };
    return Lexer;
}());
/** ReferenceConverter: Convert between A1 notation and (col, row) coordinates */
var ReferenceConverter = /** @class */ (function () {
    function ReferenceConverter() {
    }
    ReferenceConverter.parseReference = function (reference) {
        if (!reference.trim()) {
            throw new ReferenceError('Invalid reference: must be non-empty string');
        }
        var normalizedReference = reference.trim().toUpperCase();
        var currentPosition = 0;
        var isColumnAbsolute = normalizedReference[parseInt(currentPosition.toString(), 10)] === '$' ? (currentPosition++, true) : false;
        var columnLetters = '';
        while (currentPosition < normalizedReference.length && /[A-Z]/.test(normalizedReference[parseInt(currentPosition.toString(), 10)])) {
            columnLetters += normalizedReference[currentPosition++];
        }
        if (!columnLetters) {
            throw new ReferenceError("Invalid reference \"" + reference + "\": missing column letters");
        }
        var isRowAbsolute = normalizedReference[parseInt(currentPosition.toString(), 10)] === '$' ? (currentPosition++, true) : false;
        var rowText = '';
        while (currentPosition < normalizedReference.length && /[0-9]/.test(normalizedReference[parseInt(currentPosition.toString(), 10)])) {
            rowText += normalizedReference[currentPosition++];
        }
        if (!rowText || currentPosition !== normalizedReference.length) {
            throw new ReferenceError("Invalid reference \"" + reference + "\": invalid format. Use A1, B2, $C$3, etc.");
        }
        var rowIndex = parseInt(rowText, 10);
        if (rowIndex <= 0) {
            throw new ReferenceError("Invalid reference \"" + reference + "\": row must be positive");
        }
        var columnIndex = 0;
        for (var _i = 0, columnLetters_1 = columnLetters; _i < columnLetters_1.length; _i++) {
            var letter = columnLetters_1[_i];
            columnIndex = columnIndex * 26 + (letter.charCodeAt(0) - 64);
        }
        return { col: columnIndex - 1, row: rowIndex - 1, isAbsolute: { col: isColumnAbsolute, row: isRowAbsolute } };
    };
    ReferenceConverter.convertIndexToReference = function (columnIndex, rowIndex) {
        var index = parseInt(rowIndex.toString(), 10);
        if (columnIndex < 0 || index < 0) {
            throw new ReferenceError("Invalid indices: col=" + columnIndex + ", row=" + index);
        }
        var columnLetters = '';
        var adjustedColumnIndex = columnIndex + 1;
        while (adjustedColumnIndex > 0) {
            adjustedColumnIndex--;
            columnLetters = String.fromCharCode(65 + (adjustedColumnIndex % 26)) + columnLetters;
            adjustedColumnIndex = Math.floor(adjustedColumnIndex / 26);
        }
        return "" + columnLetters + (index + 1);
    };
    ReferenceConverter.adjustReferences = function (formula, rowOffset, columnOffset) {
        var _this = this;
        if (!formula) {
            return formula;
        }
        var referenceFunctionPattern = /REF\(COLUMN\((['"])([^'")]+)\1\),ROW\((\d+)\)\)/gi;
        var updatedFormula = formula.replace(referenceFunctionPattern, function (_match, quote, fieldName, rowNumber) {
            return "REF(COLUMN(" + quote + fieldName + quote + "),ROW(" + (parseInt(rowNumber, 10) + rowOffset) + "))";
        });
        var referencePattern = /(\$?[A-Z]+\$?\d+:\$?[A-Z]+\$?\d+)|(\$?[A-Z]+\$?\d+)/gi;
        return updatedFormula.replace(referencePattern, function (referenceText) {
            if (referenceText.includes(':')) {
                var _a = referenceText.split(':'), startReference = _a[0], endReference = _a[1];
                var start = _this.parseReference(startReference);
                var end = _this.parseReference(endReference);
                var startColumn = start.isAbsolute.col ? start.col : start.col + columnOffset;
                var startRow = start.isAbsolute.row ? start.row : start.row + rowOffset;
                var endColumn = end.isAbsolute.col ? end.col : end.col + columnOffset;
                var endRow = end.isAbsolute.row ? end.row : end.row + rowOffset;
                return _this.buildReference(start, startColumn, startRow) + ":" + _this.buildReference(end, endColumn, endRow);
            }
            var parsedReference = _this.parseReference(referenceText);
            var columnIndex = parsedReference.isAbsolute.col ? parsedReference.col : parsedReference.col + columnOffset;
            var rowIndex = parsedReference.isAbsolute.row ? parsedReference.row : parsedReference.row + rowOffset;
            return _this.buildReference(parsedReference, columnIndex, rowIndex);
        });
    };
    ReferenceConverter.buildReference = function (parsedReference, columnIndex, rowIndex) {
        var reference = this.convertIndexToReference(columnIndex, rowIndex);
        var matchResult = reference.match(/^([A-Z]+)(\d+)$/);
        return "" + (parsedReference.isAbsolute.col ? '$' : '') + matchResult[1]
            + ("" + (parsedReference.isAbsolute.row ? '$' : '') + matchResult[2]);
    };
    return ReferenceConverter;
}());
export { ReferenceConverter };
/** Parser: Build an AST from a token stream using recursive descent */
var Parser = /** @class */ (function () {
    function Parser() {
        this.tokens = [];
        this.position = 0;
    }
    Parser.prototype.parse = function (formula) {
        var tokenizer = new Lexer();
        this.tokens = tokenizer.tokenize(formula);
        this.position = 0;
        if (this.position < this.tokens.length && this.tokens[this.position].type === 'equals') {
            this.advance();
        }
        var expression = this.parseExpression();
        if (this.position < this.tokens.length) {
            throw new ParseError("Unexpected token after expression: " + this.tokens[this.position].value);
        }
        return expression;
    };
    Parser.prototype.parseExpression = function () {
        return this.parseRange();
    };
    Parser.prototype.parseRange = function () {
        var leftNode = this.parseComparison();
        if (!this.match(':')) {
            return leftNode;
        }
        return new RangeRefNode(leftNode, this.parseComparison());
    };
    Parser.prototype.parseComparison = function () {
        var leftNode = this.parseAdditive();
        while (this.check('comparison')) {
            var operator = this.advance().value;
            leftNode = new BinaryOpNode(operator, leftNode, this.parseAdditive());
        }
        return leftNode;
    };
    Parser.prototype.parseAdditive = function () {
        var leftNode = this.parseMultiplicative();
        while (this.match('+', '-')) {
            var operator = this.previous().value;
            leftNode = new BinaryOpNode(operator, leftNode, this.parseMultiplicative());
        }
        return leftNode;
    };
    Parser.prototype.parseMultiplicative = function () {
        var leftNode = this.parseExponentiation();
        while (this.match('*', '/', '%', '×', '÷')) {
            var operator = this.previous().value;
            leftNode = new BinaryOpNode(operator, leftNode, this.parseExponentiation());
        }
        return leftNode;
    };
    Parser.prototype.parseExponentiation = function () {
        var leftNode = this.parseUnary();
        if (!this.match('^')) {
            return leftNode;
        }
        return new BinaryOpNode('^', leftNode, this.parseExponentiation());
    };
    Parser.prototype.parseUnary = function () {
        if (!this.match('+', '-')) {
            return this.parsePrimary();
        }
        var operator = this.previous().value;
        return new UnaryOpNode(operator, this.parseUnary());
    };
    Parser.prototype.parsePrimary = function () {
        if (this.check('number')) {
            return new LiteralNode(this.advance().value);
        }
        if (this.check('string')) {
            return new LiteralNode(this.advance().value);
        }
        if (this.match('(')) {
            var expression = this.parseExpression();
            if (!this.match(')')) {
                throw new ParseError('Expected ")" after expression', this.position);
            }
            return expression;
        }
        if (this.check('reference') || this.check('function')) {
            return this.parseReferenceOrFunction();
        }
        throw new ParseError("Unexpected token: " + this.peek().value, this.position);
    };
    Parser.prototype.parseReferenceOrFunction = function () {
        var token = this.advance();
        var identifier = token.value;
        if (!this.match('(')) {
            return this.convertReferenceToNode(identifier);
        }
        var argumentsList = [];
        if (!this.check(')')) {
            do {
                argumentsList.push(this.parseExpression());
            } while (this.match(','));
        }
        if (!this.match(')')) {
            throw new ParseError('Expected ")" after function arguments', this.position);
        }
        return new FunctionCallNode(identifier, argumentsList);
    };
    Parser.prototype.convertReferenceToNode = function (reference) {
        if (!/[A-Za-z]/.test(reference) || !/[0-9]/.test(reference)) {
            throw new ParseError("Invalid cell reference: \"" + reference + "\". Use A1, B2, $C$3, etc.", this.position);
        }
        var parsedReference = ReferenceConverter.parseReference(reference);
        return new CellRefNode(reference.toUpperCase(), parsedReference.isAbsolute);
    };
    Parser.prototype.match = function () {
        var _this = this;
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        return values.some(function (value) { return _this.check(value) && (_this.advance(), true); });
    };
    Parser.prototype.check = function (value) {
        return !this.isAtEnd() && (this.peek().type === value || this.peek().value === value);
    };
    Parser.prototype.advance = function () {
        if (!this.isAtEnd()) {
            this.position++;
        }
        return this.previous();
    };
    Parser.prototype.isAtEnd = function () {
        return this.position >= this.tokens.length;
    };
    Parser.prototype.peek = function () {
        return this.tokens[this.position];
    };
    Parser.prototype.previous = function () {
        return this.tokens[this.position - 1];
    };
    return Parser;
}());
/** DependencyGraph: Track cell dependencies and detect cycles */
var DependencyGraph = /** @class */ (function () {
    function DependencyGraph() {
        this.graph = new Map();
    }
    DependencyGraph.prototype.addDependency = function (from, to) {
        var dependencies = this.graph.get(from);
        if (!dependencies) {
            dependencies = new Set();
            this.graph.set(from, dependencies);
        }
        dependencies.add(to);
    };
    DependencyGraph.prototype.removeDependency = function (from, to) {
        var dependencies = this.graph.get(from);
        if (!dependencies) {
            return;
        }
        dependencies.delete(to);
        if (dependencies.size === 0) {
            this.graph.delete(from);
        }
    };
    DependencyGraph.prototype.clear = function () {
        this.graph.clear();
    };
    DependencyGraph.prototype.detectCycles = function () {
        var _this = this;
        var visited = new Map();
        var cycleNodes = new Set();
        this.graph.forEach(function (_, node) {
            if (!visited.has(node)) {
                _this.hasCycleFromNode(node, visited, cycleNodes);
            }
        });
        return cycleNodes;
    };
    DependencyGraph.prototype.hasCycleFromNode = function (node, visited, cycleNodes) {
        var _this = this;
        visited.set(node, 1);
        var neighbors = this.graph.get(node);
        if (neighbors) {
            var hasCycle_1 = false;
            neighbors.forEach(function (neighbor) {
                if (hasCycle_1) {
                    return;
                }
                if (!visited.has(neighbor)) {
                    if (_this.hasCycleFromNode(neighbor, visited, cycleNodes)) {
                        cycleNodes.add(node);
                        hasCycle_1 = true;
                    }
                }
                else if (visited.get(neighbor) === 1) {
                    cycleNodes.add(node);
                    cycleNodes.add(neighbor);
                    hasCycle_1 = true;
                }
            });
            if (hasCycle_1) {
                return true;
            }
        }
        visited.set(node, 2);
        return false;
    };
    return DependencyGraph;
}());
/** Evaluator: Execute AST with spreadsheet type coercion */
var Evaluator = /** @class */ (function () {
    function Evaluator() {
        this.context = null;
        this.formulaEngine = null;
    }
    Evaluator.prototype.setFormulaEngine = function (formulaEngine) {
        this.formulaEngine = formulaEngine;
    };
    Evaluator.prototype.evaluate = function (astNode, evaluationContext) {
        this.context = evaluationContext;
        var result = astNode.accept(this);
        // Unwrap FormulaReferenceValue to get the actual value
        if (this.isFormulaReferenceValue(result)) {
            var unwrappedValue = result.value;
            if (this.isFormulaReferenceValue(unwrappedValue)) {
                return this.evaluate(astNode, evaluationContext);
            }
            return unwrappedValue;
        }
        return result;
    };
    Evaluator.prototype.resolveReferenceNode = function (node) {
        if (node instanceof CellRefNode) {
            return node.ref;
        }
        var value = node.accept(this);
        return this.isFormulaReferenceValue(value) ? value.ref : this.convertToReference(value);
    };
    Evaluator.prototype.visitLiteral = function (node) {
        return node.value;
    };
    Evaluator.prototype.visitCellRef = function (node) {
        return this.context.getCell(node.ref);
    };
    Evaluator.prototype.visitRangeRef = function (node) {
        var startReference = this.resolveReferenceNode(node.start);
        var endReference = this.resolveReferenceNode(node.end);
        return this.context.getRange(startReference, endReference);
    };
    Evaluator.prototype.visitBinaryOp = function (node) {
        var leftValue = node.left.accept(this);
        var rightValue = node.right.accept(this);
        switch (node.operator) {
            case '+':
                return this.convertToNumber(leftValue) + this.convertToNumber(rightValue);
            case '-':
                return this.convertToNumber(leftValue) - this.convertToNumber(rightValue);
            case '*':
            case '×':
                return this.convertToNumber(leftValue) * this.convertToNumber(rightValue);
            case '/':
            case '÷': {
                var divisor = this.convertToNumber(rightValue);
                if (divisor === 0) {
                    throw new DivideByZeroError();
                }
                return this.convertToNumber(leftValue) / divisor;
            }
            case '%':
                return this.convertToNumber(leftValue) % this.convertToNumber(rightValue);
            case '^':
                return Math.pow(this.convertToNumber(leftValue), this.convertToNumber(rightValue));
            case '>':
                return this.convertToNumber(leftValue) > this.convertToNumber(rightValue) ? 1 : 0;
            case '<':
                return this.convertToNumber(leftValue) < this.convertToNumber(rightValue) ? 1 : 0;
            case '>=':
                return this.convertToNumber(leftValue) >= this.convertToNumber(rightValue) ? 1 : 0;
            case '<=':
                return this.convertToNumber(leftValue) <= this.convertToNumber(rightValue) ? 1 : 0;
            case '=':
                return this.convertToNumber(leftValue) === this.convertToNumber(rightValue) ? 1 : 0;
            case '<>':
                return this.convertToNumber(leftValue) !== this.convertToNumber(rightValue) ? 1 : 0;
            default:
                throw new FormulaError(FormulaErrorCode.ERROR, "Unknown operator: " + node.operator);
        }
    };
    Evaluator.prototype.visitUnaryOperator = function (node) {
        var operandValue = node.operand.accept(this);
        switch (node.operator) {
            case '+':
                return this.convertToNumber(operandValue);
            case '-':
                return -this.convertToNumber(operandValue);
            default:
                throw new FormulaError(FormulaErrorCode.ERROR, "Unknown unary operator: " + node.operator);
        }
    };
    Evaluator.prototype.visitFunctionCall = function (node) {
        var functionName = node.name.toUpperCase();
        var builtInFunctions = new Set([
            'SUM', 'AVERAGE', 'COUNT', 'MIN', 'MAX', 'IF', 'ABS', 'ROUND',
            'PRODUCT', 'CONCAT', 'CONCATENATE', 'COUNTA', 'COUNTBLANK',
            'COUNTIF', 'MEDIAN', 'SUMIF', 'RAN', 'RAND', 'RANDOM',
            'TODAY', 'NOW', 'MOD', 'POWER', 'SQRT'
        ]);
        if (this.formulaEngine.parent && this.formulaEngine.parent.formulaSettings
            && this.formulaEngine.parent.formulaSettings.allowBuiltInFunctions === false
            && builtInFunctions.has(functionName)) {
            throw new UnknownFunctionError(functionName);
        }
        switch (functionName) {
            case 'SUM': {
                var total = 0;
                for (var _i = 0, _a = node.args; _i < _a.length; _i++) {
                    var argument = _a[_i];
                    var value = argument.accept(this);
                    total += this.convertToNumber(value);
                }
                return total;
            }
            case 'AVERAGE': {
                var total = 0;
                var count = 0;
                for (var _b = 0, _c = node.args; _b < _c.length; _b++) {
                    var argument = _c[_b];
                    var values = this.extractValues(argument.accept(this));
                    for (var _d = 0, values_1 = values; _d < values_1.length; _d++) {
                        var value = values_1[_d];
                        total += this.convertToNumber(value);
                        count++;
                    }
                }
                return count > 0 ? total / count : 0;
            }
            case 'COUNT': {
                var count = 0;
                for (var _e = 0, _f = node.args; _e < _f.length; _e++) {
                    var argument = _f[_e];
                    var values = this.extractValues(argument.accept(this));
                    for (var _g = 0, values_2 = values; _g < values_2.length; _g++) {
                        var value = values_2[_g];
                        if (this.tryParseNumber(value) !== undefined) {
                            count++;
                        }
                    }
                }
                return count;
            }
            case 'MIN': {
                var minimumValue = Infinity;
                for (var _h = 0, _j = node.args; _h < _j.length; _h++) {
                    var argument = _j[_h];
                    var values = this.extractValues(argument.accept(this));
                    for (var _k = 0, values_3 = values; _k < values_3.length; _k++) {
                        var value = values_3[_k];
                        minimumValue = Math.min(minimumValue, this.convertToNumber(value));
                    }
                }
                return minimumValue === Infinity ? 0 : minimumValue;
            }
            case 'MAX': {
                var maximumValue = -Infinity;
                for (var _l = 0, _m = node.args; _l < _m.length; _l++) {
                    var argument = _m[_l];
                    var values = this.extractValues(argument.accept(this));
                    for (var _o = 0, values_4 = values; _o < values_4.length; _o++) {
                        var value = values_4[_o];
                        maximumValue = Math.max(maximumValue, this.convertToNumber(value));
                    }
                }
                return maximumValue === -Infinity ? 0 : maximumValue;
            }
            case 'IF': {
                if (node.args.length < 3) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'IF requires 3 arguments: condition, true_value, false_value');
                }
                var condition = this.convertToBoolean(node.args[0].accept(this));
                return condition ? node.args[1].accept(this) : node.args[2].accept(this);
            }
            case 'REF': {
                if (node.args.length < 2) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'REF requires 2 arguments: column reference and row number');
                }
                var columnReference = node.args[0].accept(this);
                var rowNumber = node.args[1].accept(this);
                if (typeof columnReference !== 'string') {
                    throw new ReferenceError("Cannot resolve REF(" + columnReference + ", " + rowNumber + ")");
                }
                var rowData = this.context.getRowData(rowNumber);
                if (!rowData || !(columnReference in rowData) || rowData[columnReference] === undefined) {
                    throw new ReferenceError("Cannot resolve REF(" + columnReference + ", " + rowNumber + ")");
                }
                var referenceText = this.context.getFieldReference(columnReference, rowNumber);
                if (!referenceText) {
                    throw new ReferenceError("Cannot resolve REF(" + columnReference + ", " + rowNumber + ")");
                }
                return {
                    __isFormulaRefValue: true,
                    ref: referenceText,
                    value: this.context.getCell(referenceText)
                };
            }
            case 'COLUMN': {
                if (node.args.length < 1 || node.args[0] instanceof LiteralNode === false) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'COLUMN requires a field name string argument');
                }
                return node.args[0].accept(this);
            }
            case 'ROW': {
                if (node.args.length < 1) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'ROW requires a row number argument');
                }
                return node.args[0].accept(this);
            }
            case 'ABS': {
                if (node.args.length < 1) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'ABS requires 1 argument');
                }
                return Math.abs(this.convertToNumber(node.args[0].accept(this)));
            }
            case 'ROUND': {
                if (node.args.length < 1) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'ROUND requires at least 1 argument: value[, decimals]');
                }
                var value = this.convertToNumber(node.args[0].accept(this));
                var decimals = node.args.length > 1 ? this.convertToNumber(node.args[1].accept(this)) : 0;
                return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
            }
            case 'PRODUCT': {
                if (node.args.length === 0) {
                    return 0;
                }
                var product = 1;
                for (var _p = 0, _q = node.args; _p < _q.length; _p++) {
                    var argument = _q[_p];
                    var values = this.extractValues(argument.accept(this));
                    for (var _r = 0, values_5 = values; _r < values_5.length; _r++) {
                        var value = values_5[_r];
                        product *= this.convertToNumber(value);
                    }
                }
                return product;
            }
            case 'CONCAT': {
                var parts = [];
                for (var _s = 0, _t = node.args; _s < _t.length; _s++) {
                    var arg = _t[_s];
                    this.appendConcatenatedValue(arg.accept(this), parts);
                }
                return parts.join('');
            }
            case 'COUNTA': {
                var count = 0;
                for (var _u = 0, _v = node.args; _u < _v.length; _u++) {
                    var arg = _v[_u];
                    var values = this.extractValues(arg.accept(this));
                    for (var _w = 0, values_6 = values; _w < values_6.length; _w++) {
                        var value = values_6[_w];
                        if (value !== null && value !== undefined) {
                            count++;
                        }
                    }
                }
                return count;
            }
            case 'COUNTBLANK': {
                var count = 0;
                for (var _x = 0, _y = node.args; _x < _y.length; _x++) {
                    var arg = _y[_x];
                    var values = this.extractValues(arg.accept(this));
                    for (var _z = 0, values_7 = values; _z < values_7.length; _z++) {
                        var value = values_7[_z];
                        if (value === null || value === undefined || value === '') {
                            count++;
                        }
                    }
                }
                return count;
            }
            case 'COUNTIF': {
                if (node.args.length < 2) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'COUNTIF requires 2 arguments: range, criteria');
                }
                var rangeValues = this.extractValues(node.args[0].accept(this));
                var criteria = node.args[1].accept(this);
                var count = 0;
                for (var _0 = 0, rangeValues_1 = rangeValues; _0 < rangeValues_1.length; _0++) {
                    var value = rangeValues_1[_0];
                    if (this.matchesCriteria(value, criteria)) {
                        count++;
                    }
                }
                return count;
            }
            case 'MEDIAN': {
                var numericValues = [];
                for (var _1 = 0, _2 = node.args; _1 < _2.length; _1++) {
                    var argument = _2[_1];
                    var values = this.extractValues(argument.accept(this));
                    for (var _3 = 0, values_8 = values; _3 < values_8.length; _3++) {
                        var value = values_8[_3];
                        var numericValue = this.tryParseNumber(value);
                        if (numericValue !== undefined) {
                            numericValues.push(numericValue);
                        }
                    }
                }
                if (numericValues.length === 0) {
                    return 0;
                }
                numericValues.sort(function (leftValue, rightValue) { return leftValue - rightValue; });
                var middleIndex = Math.floor(numericValues.length / 2);
                return numericValues.length % 2 === 1 ? numericValues[parseInt(middleIndex.toString(), 10)] :
                    (numericValues[parseInt(middleIndex.toString(), 10) - 1] + numericValues[parseInt(middleIndex.toString(), 10)]) / 2;
            }
            case 'SUMIF': {
                if (node.args.length < 2) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'SUMIF requires 2 or 3 arguments: range, criteria[, sum_range]');
                }
                var criteriaValues = this.extractValues(node.args[0].accept(this));
                var criteria = node.args[1].accept(this);
                var sumValues = node.args.length > 2
                    ? this.extractValues(node.args[2].accept(this)) : criteriaValues;
                var total = 0;
                for (var index = 0; index < criteriaValues.length; index++) {
                    if (this.matchesCriteria(
                    // eslint-disable-next-line security/detect-object-injection
                    criteriaValues[index], criteria)) {
                        // eslint-disable-next-line security/detect-object-injection
                        var sumValue = index < sumValues.length ? sumValues[index] : 0;
                        total += this.convertToNumber(sumValue);
                    }
                }
                return total;
            }
            case 'RAND': {
                return Math.random();
            }
            case 'TODAY': {
                var currentDate = new Date();
                return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            }
            case 'NOW': {
                return new Date();
            }
            case 'MOD': {
                if (node.args.length < 2) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'MOD requires 2 arguments: dividend, divisor');
                }
                var dividendValue = node.args[0].accept(this);
                var divisorValue = node.args[1].accept(this);
                var dividend = this.convertToNumber(Array.isArray(dividendValue) && dividendValue.length > 0 ? dividendValue[0] : dividendValue);
                var divisor = this.convertToNumber(Array.isArray(divisorValue) && divisorValue.length > 0 ? divisorValue[0] : divisorValue);
                if (divisor === 0) {
                    throw new DivideByZeroError();
                }
                return dividend - divisor * Math.floor(dividend / divisor);
            }
            case 'POWER': {
                if (node.args.length < 2) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'POWER requires 2 arguments: base, exponent');
                }
                var baseValue = node.args[0].accept(this);
                var exponentValue = node.args[1].accept(this);
                var base = this.convertToNumber(Array.isArray(baseValue) && baseValue.length > 0 ? baseValue[0] : baseValue);
                var exponent = this.convertToNumber(Array.isArray(exponentValue) && exponentValue.length > 0 ?
                    exponentValue[0] : exponentValue);
                return Math.pow(base, exponent);
            }
            case 'SQRT': {
                if (node.args.length < 1) {
                    throw new FormulaError(FormulaErrorCode.ERROR, 'SQRT requires 1 argument');
                }
                var value = node.args[0].accept(this);
                var numericValue = this.convertToNumber(Array.isArray(value) && value.length > 0 ? value[0] : value);
                if (numericValue < 0) {
                    throw new FormulaError(FormulaErrorCode.VALUE, 'SQRT requires non-negative argument');
                }
                return Math.sqrt(numericValue);
            }
            default: {
                if (this.formulaEngine && this.formulaEngine.isCustomFunction(functionName)) {
                    return this.executeCustomFunction(node, functionName);
                }
                throw new UnknownFunctionError("Function not yet implemented: " + node.name);
            }
        }
    };
    Evaluator.prototype.executeCustomFunction = function (node, funcName) {
        if (!this.formulaEngine) {
            throw new FormulaError(FormulaErrorCode.ERROR, "Custom function engine not available for " + funcName);
        }
        var evaluatedArgs = [];
        for (var _i = 0, _a = node.args; _i < _a.length; _i++) {
            var arg = _a[_i];
            evaluatedArgs.push(arg.accept(this));
        }
        var values = [];
        for (var _b = 0, evaluatedArgs_1 = evaluatedArgs; _b < evaluatedArgs_1.length; _b++) {
            var arg = evaluatedArgs_1[_b];
            if (this.isFormulaReferenceValue(arg)) {
                // Handle FormulaReferenceValue by extracting its value
                var refValue = arg.value;
                if (Array.isArray(refValue)) {
                    values.push.apply(values, refValue);
                }
                else if (refValue !== null && refValue !== undefined) {
                    values.push(refValue);
                }
            }
            else if (Array.isArray(arg)) {
                values.push.apply(values, arg);
            }
            else if (arg !== null && arg !== undefined) {
                values.push(arg);
            }
        }
        var params = { values: values, args: evaluatedArgs, context: this.context };
        var customFunc = this.formulaEngine.getCustomFunction(funcName);
        if (!customFunc) {
            throw new UnknownFunctionError("Custom function not found: " + funcName);
        }
        var eventArgs = { name: funcName, params: params, result: undefined, error: undefined, requestType: 'customFunctions' };
        this.formulaEngine.parent.trigger('customFunctions', eventArgs, function (args) {
            if (args.cancel) {
                throw new FormulaError(FormulaErrorCode.ERROR, "Custom formula " + funcName + " was cancelled by event handler");
            }
        });
        if (typeof customFunc === 'function') {
            return customFunc(params);
        }
        else if (customFunc && typeof customFunc.func === 'function') {
            return customFunc.func(params);
        }
        else {
            throw new FormulaError(FormulaErrorCode.ERROR, "Custom function " + funcName + " is not callable");
        }
    };
    Evaluator.prototype.isFormulaReferenceValue = function (value) {
        return typeof value === 'object' && value !== null && '__isFormulaRefValue' in value && value.__isFormulaRefValue === true;
    };
    Evaluator.prototype.convertToNumber = function (value) {
        var _this = this;
        if (this.isFormulaReferenceValue(value)) {
            return this.convertToNumber(value.value);
        }
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'boolean') {
            return value ? 1 : 0;
        }
        if (value === null || value === undefined) {
            return 0;
        }
        if (typeof value === 'string') {
            if (value === '') {
                return 0;
            }
            var numericValue = parseFloat(value);
            if (!isNaN(numericValue)) {
                return numericValue;
            }
            throw new TypeMismatchError("Cannot convert string to number: \"" + value + "\"");
        }
        if (Array.isArray(value)) {
            return value.reduce(function (total, item) { return total + (_this.tryParseNumber(item) || 0); }, 0);
        }
        throw new TypeMismatchError("Cannot convert " + typeof value + " to number");
    };
    Evaluator.prototype.convertToBoolean = function (value) {
        if (this.isFormulaReferenceValue(value)) {
            return this.convertToBoolean(value.value);
        }
        if (typeof value === 'boolean') {
            return value;
        }
        if (typeof value === 'number') {
            return value !== 0;
        }
        if (typeof value === 'string') {
            return value.length > 0;
        }
        if (value === null || value === undefined) {
            return false;
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        return !!value;
    };
    Evaluator.prototype.extractValues = function (value) {
        var _this = this;
        if (this.isFormulaReferenceValue(value)) {
            return this.extractValues(value.value);
        }
        if (value === null || value === undefined) {
            return [value];
        }
        if (Array.isArray(value)) {
            return value.reduce(function (result, item) { return result.concat(_this.extractValues(item)); }, []);
        }
        return [value];
    };
    Evaluator.prototype.appendConcatenatedValue = function (value, parts) {
        if (this.isFormulaReferenceValue(value)) {
            this.appendConcatenatedValue(value.value, parts);
            return;
        }
        if (Array.isArray(value)) {
            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                var item = value_1[_i];
                this.appendConcatenatedValue(item, parts);
            }
            return;
        }
        if (value === null || value === undefined) {
            return;
        }
        parts.push(String(value));
    };
    Evaluator.prototype.matchesCriteria = function (value, criteria) {
        var actualValue = this.isFormulaReferenceValue(value) ? value.value : value;
        var actualCriteria = this.isFormulaReferenceValue(criteria) ? criteria.value : criteria;
        if (actualCriteria === null || actualCriteria === undefined) {
            return actualValue === null || actualValue === undefined || actualValue === '';
        }
        if (typeof actualCriteria === 'string') {
            var trimmed = actualCriteria.trim();
            var operatorMatch = trimmed.match(/^(>=|<=|<>|=|>|<)(.*)$/);
            if (operatorMatch) {
                var operator = operatorMatch[1];
                var operand = operatorMatch[2].trim();
                var numericOperand = parseFloat(operand);
                var leftNumber = this.tryParseNumber(actualValue);
                switch (operator) {
                    case '=':
                        return String(actualValue) === operand || (leftNumber !== undefined && leftNumber === numericOperand);
                    case '<>':
                        return String(actualValue) !== operand && (leftNumber === undefined || leftNumber !== numericOperand);
                    case '>':
                        return leftNumber !== undefined && leftNumber > numericOperand;
                    case '<':
                        return leftNumber !== undefined && leftNumber < numericOperand;
                    case '>=':
                        return leftNumber !== undefined && leftNumber >= numericOperand;
                    case '<=':
                        return leftNumber !== undefined && leftNumber <= numericOperand;
                }
            }
            return String(actualValue) === trimmed;
        }
        if (typeof actualCriteria === 'number' || typeof actualCriteria === 'boolean') {
            if (typeof actualValue === 'number' || typeof actualValue === 'boolean') {
                return actualValue === actualCriteria;
            }
            var converted = this.tryParseNumber(actualValue);
            return converted !== undefined && converted === this.convertToNumber(actualCriteria);
        }
        return String(actualValue) === String(actualCriteria);
    };
    Evaluator.prototype.tryParseNumber = function (value) {
        if (this.isFormulaReferenceValue(value)) {
            return this.tryParseNumber(value.value);
        }
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'boolean') {
            return value ? 1 : 0;
        }
        if (value === null || value === undefined || value === '') {
            return undefined;
        }
        if (typeof value === 'string') {
            var number = parseFloat(value);
            return !isNaN(number) ? number : undefined;
        }
        if (Array.isArray(value) && value.length > 0) {
            return this.tryParseNumber(value[0]);
        }
        return undefined;
    };
    Evaluator.prototype.convertToReference = function (value) {
        if (this.isFormulaReferenceValue(value)) {
            return value.ref;
        }
        if (typeof value === 'string') {
            var reference = value.trim().toUpperCase();
            if (/^\$?[A-Z]+\$?\d+$/.test(reference)) {
                return reference;
            }
        }
        throw new ReferenceError("Cannot convert value to cell reference: " + value);
    };
    return Evaluator;
}());
/** Coordinator for formula parsing, evaluation, and dependency tracking */
var Formula = /** @class */ (function () {
    function Formula(grid) {
        this.parser = new Parser();
        this.evaluator = new Evaluator();
        this.dependencyGraph = new DependencyGraph();
        this.formulaCache = new Map();
        this.customFunctions = new Map();
        this.parent = grid;
        this.initializeCustomFunctions();
        this.addEventListener();
    }
    /**
     * @returns {void}
     * @hidden
     */
    Formula.prototype.addEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(events.destroy, this.destroy, this);
    };
    /**
     * @returns {void}
     * @hidden
     */
    Formula.prototype.removeEventListener = function () {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(events.destroy, this.destroy);
    };
    /**
     * Initializes custom formula functions from the component settings.
     *
     * @returns {void}
     */
    Formula.prototype.initializeCustomFunctions = function () {
        if (this.parent && this.parent.formulaSettings && this.parent.formulaSettings.customFunctions) {
            var customFormulas = this.parent.formulaSettings.customFunctions;
            for (var _i = 0, _a = Object.keys(customFormulas); _i < _a.length; _i++) {
                var name_1 = _a[_i];
                // eslint-disable-next-line security/detect-object-injection
                var func = customFormulas[name_1];
                this.registerCustomFunction(name_1.toUpperCase(), func);
            }
        }
    };
    Formula.prototype.registerCustomFunction = function (name, func) {
        if (typeof func === 'function' || (func && typeof func === 'object')) {
            this.customFunctions.set(name.toUpperCase(), func);
        }
    };
    Formula.prototype.getCustomFunction = function (name) {
        return this.customFunctions.get(name.toUpperCase());
    };
    Formula.prototype.isCustomFunction = function (name) {
        return this.customFunctions.has(name.toUpperCase());
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} returns the module name
     * @private
     */
    Formula.prototype.getModuleName = function () {
        return 'formula';
    };
    /**
     * Sets a formula for a cell.
     *
     * @param {number | string} primaryKeyValue - The row index or primary key of the record.
     * @param {string} field - The field name for which the formula is being set.
     * @param {string | undefined} formula - The formula to store, or undefined to clear the formula.
     * @returns {void}
     */
    Formula.prototype.setCellFormula = function (primaryKeyValue, field, formula) {
        var key = this.getCacheKey(primaryKeyValue, field);
        if (formula === undefined || formula.trim() === '') {
            this.formulaCache.delete(key);
            return;
        }
        this.primaryKeyValue = primaryKeyValue;
        var trimmedFormula = formula.trim();
        try {
            if (!trimmedFormula.startsWith('=')) {
                if (!/[+\-*/%():\w]/.test(trimmedFormula)) {
                    throw new ParseError('Formula must start with "=" or contain valid formula syntax');
                }
            }
            var ast = this.parser.parse(trimmedFormula.replace(/\$/g, ''));
            var refs = this.extractReferences(ast);
            if (refs.length > 0) {
                for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
                    var ref = refs_1[_i];
                    this.dependencyGraph.addDependency(key, ref);
                }
                var cycles = this.dependencyGraph.detectCycles();
                if (cycles.has(key)) {
                    for (var _a = 0, refs_2 = refs; _a < refs_2.length; _a++) {
                        var ref = refs_2[_a];
                        this.dependencyGraph.removeDependency(key, ref);
                    }
                }
            }
            var context = this.createContext();
            if (!context) {
                throw new FormulaError(FormulaErrorCode.ERROR, "Cannot create evaluation context for " + key);
            }
            this.evaluator.setFormulaEngine(this);
            var value = this.evaluator.evaluate(ast, context);
            if (value && this.evaluator.isFormulaReferenceValue(value)) {
                value = value.value;
            }
            else if (Array.isArray(value)) {
                throw new FormulaError(FormulaErrorCode.ERROR, "Cannot create evaluation context for " + key);
            }
            var finalValue = value;
            this.formulaCache.set(key, { ast: ast, value: finalValue, error: undefined, formula: trimmedFormula });
        }
        catch (error) {
            var formulaError = void 0;
            if (error instanceof FormulaError) {
                formulaError = error;
            }
            else {
                formulaError = new FormulaError(FormulaErrorCode.PARSE, "Failed to process formula: " + (error instanceof Error ? error.message : String(error)));
            }
            this.formulaCache.set(key, { ast: undefined, value: formulaError, error: formulaError, formula: trimmedFormula });
        }
    };
    /**
     * Gets a stored formula.
     *
     * @param {number | string} primaryKeyValue - The row index or primary key of the record.
     * @param {string} field - The field name containing the formula.
     * @returns {string | undefined} The stored formula, or undefined if no formula exists.
     */
    Formula.prototype.getCellFormula = function (primaryKeyValue, field) {
        var key = this.getCacheKey(primaryKeyValue, field);
        var cached = this.formulaCache.get(key);
        if (cached) {
            if (cached.formula) {
                return cached.formula;
            }
        }
        return undefined;
    };
    /**
     * Gets the evaluated value of a formula.
     *
     * @param {number | string} primaryKeyValue - The row index or primary key of the record.
     * @param {string} field - The field name containing the formula.
     * @returns {FormulaValue | undefined} The evaluated formula value, or undefined if no value is available.
     */
    Formula.prototype.getFormulaValue = function (primaryKeyValue, field) {
        var key = this.getCacheKey(primaryKeyValue, field);
        var cached = this.formulaCache.get(key);
        return cached ? cached.value : undefined;
    };
    /**
     * Extracts all cell references from an abstract syntax tree (AST).
     * For ranges, extracts all cells within the range to track dependencies.
     *
     * @param {ASTNode} astNode - The AST node from which to extract cell references.
     * @returns {string[]} A collection of extracted cell references.
     */
    Formula.prototype.extractReferences = function (astNode) {
        var _this = this;
        var cellReferences = [];
        var processedReferences = new Set();
        var visitor = {
            visitLiteral: function () { return undefined; },
            visitCellRef: function (cellReferenceNode) {
                if (!processedReferences.has(cellReferenceNode.ref)) {
                    cellReferences.push(cellReferenceNode.ref);
                    processedReferences.add(cellReferenceNode.ref);
                }
                return undefined;
            },
            visitRangeRef: function (rangeReferenceNode) {
                var startCellReference;
                var endCellReference;
                if (rangeReferenceNode.start instanceof CellRefNode) {
                    startCellReference = rangeReferenceNode.start.ref;
                }
                else {
                    var startCellReferences = _this.extractReferences(rangeReferenceNode.start);
                    startCellReference = startCellReferences.length > 0 ? startCellReferences[0] : undefined;
                }
                if (rangeReferenceNode.end instanceof CellRefNode) {
                    endCellReference = rangeReferenceNode.end.ref;
                }
                else {
                    var endCellReferences = _this.extractReferences(rangeReferenceNode.end);
                    endCellReference = endCellReferences.length > 0 ? endCellReferences[0] : undefined;
                }
                if (!startCellReference || !endCellReference) {
                    rangeReferenceNode.start.accept(visitor);
                    rangeReferenceNode.end.accept(visitor);
                    return undefined;
                }
                var startReferenceInfo = ReferenceConverter.parseReference(startCellReference);
                var endReferenceInfo = ReferenceConverter.parseReference(endCellReference);
                for (var rowIndex = startReferenceInfo.row; rowIndex <= endReferenceInfo.row; rowIndex++) {
                    for (var columnIndex = startReferenceInfo.col; columnIndex <= endReferenceInfo.col; columnIndex++) {
                        var currentCellReference = ReferenceConverter.convertIndexToReference(columnIndex, rowIndex);
                        if (!processedReferences.has(currentCellReference)) {
                            cellReferences.push(currentCellReference);
                            processedReferences.add(currentCellReference);
                        }
                    }
                }
                return undefined;
            },
            visitBinaryOp: function (binaryOperationNode) {
                binaryOperationNode.left.accept(visitor);
                binaryOperationNode.right.accept(visitor);
                return undefined;
            },
            visitUnaryOperator: function (unaryOperatorNode) {
                unaryOperatorNode.operand.accept(visitor);
                return undefined;
            },
            visitFunctionCall: function (functionCallNode) {
                functionCallNode.args.forEach(function (argumentNode) { return argumentNode.accept(visitor); });
                return undefined;
            }
        };
        astNode.accept(visitor);
        return cellReferences;
    };
    /**
     * Resolve a cell value from the grid.
     *
     * @param {string} cellReference - The cell reference to resolve.
     * @returns {FormulaValue | undefined} The resolved cell value, or undefined if not found.
     */
    Formula.prototype.resolveCellValue = function (cellReference) {
        if (!cellReference || typeof cellReference !== 'string') {
            return undefined;
        }
        var parsedReference = ReferenceConverter.parseReference(cellReference);
        var dataSource = this.parent.getDataModule().dataManager.executeLocal(new Query());
        var primaryKeyField = this.parent.getPrimaryKeyFieldNames()[0];
        var index = dataSource.findIndex(function (item) { return item["" + primaryKeyField] === parsedReference.row; });
        var targetRowData = dataSource[parseInt(index.toString(), 10)];
        if (!targetRowData) {
            return undefined;
        }
        var validColumns = this.parent.getColumns().filter(function (column) { return column && column.field !== undefined && column.field !== null; });
        if (parsedReference.col < 0 || parsedReference.col >= validColumns.length) {
            return undefined;
        }
        var fieldName = validColumns[parsedReference.col].field;
        // eslint-disable-next-line security/detect-object-injection
        var cellValue = targetRowData[fieldName];
        if (typeof cellValue === 'string' && cellValue.trim().startsWith('=') && this.parent.formulaModule) {
            var rowIdentifier = this.getRowId(targetRowData, parsedReference.row);
            var evaluatedFormulaValue = this.getFormulaValue(rowIdentifier, fieldName);
            if (evaluatedFormulaValue !== undefined) {
                return evaluatedFormulaValue;
            }
        }
        return cellValue;
    };
    Formula.prototype.getRowId = function (rowData, rowIndex) {
        var primaryKeyFields = this.parent.getPrimaryKeyFieldNames ? this.parent.getPrimaryKeyFieldNames() : [];
        if (primaryKeyFields.length > 0) {
            var primaryKey = primaryKeyFields[0];
            if (!isNullOrUndefined(rowData["" + primaryKey])) {
                return rowData["" + primaryKey];
            }
        }
        return rowIndex;
    };
    /**
     * Resolves a range of values from the grid. Handles ranges such as A1:A5 and B2:D10.
     *
     * @param {string} startReference - The starting cell reference of the range.
     * @param {string} endReference - The ending cell reference of the range.
     * @returns {FormulaValue[]} The values contained within the specified range.
     */
    Formula.prototype.resolveRangeValues = function (startReference, endReference) {
        var startCellReference = ReferenceConverter.parseReference(startReference);
        var endCellReference = ReferenceConverter.parseReference(endReference);
        var rangeValues = [];
        if (startCellReference.row > endCellReference.row || startCellReference.col > endCellReference.col) {
            var originalColumnIndex = startCellReference.col;
            var originalRowIndex = startCellReference.row;
            startCellReference.col = Math.min(startCellReference.col, endCellReference.col);
            startCellReference.row = Math.min(startCellReference.row, endCellReference.row);
            endCellReference.col = Math.max(originalColumnIndex, endCellReference.col);
            endCellReference.row = Math.max(originalRowIndex, endCellReference.row);
        }
        for (var rowIndex = startCellReference.row; rowIndex <= endCellReference.row; rowIndex++) {
            for (var columnIndex = startCellReference.col; columnIndex <= endCellReference.col; columnIndex++) {
                var currentCellReference = ReferenceConverter.convertIndexToReference(columnIndex, rowIndex);
                var currentCellValue = this.resolveCellValue(currentCellReference);
                rangeValues.push(currentCellValue);
            }
        }
        return rangeValues;
    };
    /**
     * Creates an evaluation context for formula processing.
     *
     * @returns {EvaluationContext} A new evaluation context.
     */
    Formula.prototype.createContext = function () {
        var _this = this;
        return {
            getCell: function (cellReference) { return _this.resolveCellValue(cellReference); },
            getRange: function (startReference, endReference) {
                return _this.resolveRangeValues(startReference, endReference);
            },
            getRowData: function (rowIndex) {
                var dataSource = _this.parent.getDataModule().dataManager.executeLocal(new Query());
                var primaryKeyField = _this.parent.getPrimaryKeyFieldNames()[0];
                var index = dataSource.findIndex(function (item) { return item["" + primaryKeyField] === rowIndex; });
                return dataSource[parseInt(index.toString(), 10)];
            },
            getFieldReference: function (fieldName, rowIndex) {
                var dataColumns = _this.parent.getColumns().filter(function (column) {
                    return column && column.field !== undefined && column.field !== null;
                });
                var columnIndex = dataColumns.findIndex(function (column) { return column.field === fieldName; });
                return ReferenceConverter.convertIndexToReference(columnIndex, rowIndex);
            }
        };
    };
    Formula.prototype.getCacheKey = function (rowIndex, field) {
        return rowIndex + ":" + field;
    };
    /**
     * Gets all formulas defined in the grid.
     *
     * @returns {FormulaDefinitionModel[]} Array of formula definitions with their values.
     */
    Formula.prototype.getFormulas = function () {
        var formulas = [];
        this.formulaCache.forEach(function (cacheEntry, cacheKey) {
            if (cacheEntry && cacheEntry.formula) {
                var parts = cacheKey.split(':');
                if (parts.length === 2) {
                    var rowIndexPart = parts[0];
                    var field = parts[1];
                    var rowIndex = isNaN(Number(rowIndexPart)) ? rowIndexPart : Number(rowIndexPart);
                    formulas.push({ rowIndex: rowIndex, field: field, formula: cacheEntry.formula,
                        value: cacheEntry.value instanceof FormulaError ? undefined : cacheEntry.value
                    });
                }
            }
        });
        return formulas;
    };
    /**
     * Checks if a formula exists for the specified cell.
     *
     * @param {number} primaryKeyValue - The row index of the cell.
     * @param {string} field - The field name of the cell.
     * @returns {boolean} True if a formula exists for the cell, otherwise false.
     */
    Formula.prototype.hasFormula = function (primaryKeyValue, field) {
        var key = this.getCacheKey(primaryKeyValue, field);
        var cached = this.formulaCache.get(key);
        return cached !== undefined && cached.formula !== undefined && cached.formula.trim().length > 0;
    };
    /**
     * Adds a custom formula function.
     *
     * @param {string} name - The name of the custom formula function.
     * @param {Function} handler - The handler function for the custom formula.
     * @returns {void}
     */
    Formula.prototype.addFormula = function (name, handler) {
        var normalizedName = name.toUpperCase();
        this.registerCustomFunction(normalizedName, handler);
    };
    /**
     * Removes a custom formula function.
     *
     * @param {string} name - The name of the custom formula function to remove.
     * @returns {void}
     */
    Formula.prototype.removeFormula = function (name) {
        var normalizedName = name.toUpperCase();
        this.customFunctions.delete(normalizedName);
    };
    /**
     * Destroys the formula module.
     *
     * @returns {void}
     */
    Formula.prototype.destroy = function () {
        this.removeEventListener();
        this.formulaCache.clear();
        this.customFunctions.clear();
        this.dependencyGraph.clear();
        this.parser = null;
        this.evaluator = null;
    };
    return Formula;
}());
export { Formula };
